var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.35355 0.646447C1.15829 0.451184 0.841709 0.451184 0.646447 0.646447C0.451184 0.841709 0.451184 1.15829 0.646447 1.35355L1.35355 0.646447ZM9.64645 10.3536C9.84171 10.5488 10.1583 10.5488 10.3536 10.3536C10.5488 10.1583 10.5488 9.84171 10.3536 9.64645L9.64645 10.3536ZM0.646447 1.35355L9.64645 10.3536L10.3536 9.64645L1.35355 0.646447L0.646447 1.35355Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64645 0.646447C9.84171 0.451184 10.1583 0.451184 10.3536 0.646447C10.5488 0.841709 10.5488 1.15829 10.3536 1.35355L9.64645 0.646447ZM1.35355 10.3536C1.15829 10.5488 0.841709 10.5488 0.646446 10.3536C0.451184 10.1583 0.451184 9.84171 0.646446 9.64645L1.35355 10.3536ZM10.3536 1.35355L1.35355 10.3536L0.646446 9.64645L9.64645 0.646447L10.3536 1.35355Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.06b5570e6330e9095e27a4c877ae11bc.svg";
export { ForwardRef as ReactComponent };